var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-5"},[_c('circles-spinner',{attrs:{"animation-duration":2000,"rhombus-size":10,"color":"#6c757d"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }